var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1a {\n        fill: #5f6368;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1a",
    d: "M58.5,55.9h0c1.4,0,2.5-1.1,2.5-2.5v-4.3h4c1.4,0,2.5-1.1,2.5-2.5h0c0-1.4-1.1-2.5-2.5-2.5h-4v-4.3c0-1.4-1.1-2.5-2.5-2.5h0c-1.4,0-2.5,1.1-2.5,2.5v4.3h-4c-1.4,0-2.5,1.1-2.5,2.5h0c0,1.4,1.1,2.5,2.5,2.5h4v4.3c0,1.4,1.1,2.5,2.5,2.5ZM39.6,63.5V29.5c0-1.1.9-2,2-2h34c1.1,0,2,.9,2,2v34c0,1.1-.9,2-2,2h-34c-1.1,0-2-.9-2-2ZM46.3,59.9h24.4c.7,0,1.3-.6,1.3-1.3v-24.4c0-.7-.6-1.3-1.3-1.3h-24.4c-.7,0-1.3.6-1.3,1.3v24.4c0,.7.6,1.3,1.3,1.3ZM27.5,75.4v-35.2c0-1.5,1.2-2.7,2.7-2.7h0c1.5,0,2.7,1.2,2.7,2.7v30.4c0,.7.6,1.3,1.3,1.3h30.4c1.5,0,2.7,1.2,2.7,2.7h0c0,1.5-1.2,2.8-2.7,2.8H29.6c-1.1,0-2.1-.9-2.1-2.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryAdd);
export default __webpack_public_path__ + "static/media/library_add.eb292c74ad78c2c7a520ace776cb9772.svg";
export { ForwardRef as ReactComponent };